import { fetchDataFromURL } from '../api/fetchDataFromURL';
import ActionTypes from './types';

/** @param {import('../typings').HomePageState} props */
export const fetchInterestRatesAction =
  (props) => async (dispatch) => {
    try {
      const {
        selectedGroupCallValue,
        currentDate,
        toggleRemoveWeeksTable2,
        selectedResultCallValue,
      } = props;

      await dispatch({
        type: ActionTypes.SET_APP_STATE,
        payload: {
          weekendErrorsBox2: null,
          secondLoading: true,
        },
      });


      const data = await fetchDataFromURL(
        `/api/get-secondhometable-data?group=${selectedGroupCallValue}&date=${currentDate}&limit=${selectedResultCallValue}&removeWeeksTable2=${toggleRemoveWeeksTable2}`
      );
      if (data && data.length) {
        dispatch({
          type: ActionTypes.SET_APP_STATE,
          payload: {
            weekendErrorsBox2: null,
            homeSecondTable: data,
            secondLoading: false,
          },
        });
      } else {
        dispatch({
          type: ActionTypes.SET_APP_STATE,
          payload: {
            weekendErrorsBox2:
              "Can't Get Data Might be Weekend or Holiday",
            homeSecondTable: [],
            secondLoading: false,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: ActionTypes.SET_APP_STATE,
        payload: {
          homeSecondTable: [],
          weekendErrorsBox2:
            "Can't Get Data Might be Weekend or Holiday",
          secondLoading: false,
        },
      });
    }
  };



// WEBPACK FOOTER //
// ./src/actions/InterestRatesAction.js